import React from "react"
import { useLanguage } from "../../../context/LanguageContext"

const PriceCard = () => {
  const { content } = useLanguage()
  const { pricing } = content.home

  return (
    <>
      <div className='content flex mtop'>
        {pricing.items.map((item) => (
          <div className='box shadow' key={item.planKey}>
            <div className='topbtn'>
              {item.best ? (
                <button type='button' className='btn3'>
                  {item.best}
                </button>
              ) : null}
            </div>
            <h3>{item.plan}</h3>
            <h1>
              <span>{item.currency}</span>
              {item.price}
            </h1>
            <p>{item.ptext}</p>

            <ul>
              {item.list.map((feature) => {
                const { iconClass, text, change } = feature
                return (
                  <li key={`${item.planKey}-${text}`}>
                    <label
                      style={{
                        background: change === "negative" ? "#dc35451f" : "#27ae601f",
                        color: change === "negative" ? "#dc3848" : "#27ae60",
                      }}
                    >
                      <i className={iconClass}></i>
                    </label>
                    <p>{text}</p>
                  </li>
                )
              })}
            </ul>
            <button
              type='button'
              className='btn5'
              style={{
                background: item.planKey === "standard" ? "#27ae60" : "#fff",
                color: item.planKey === "standard" ? "#fff" : "#27ae60",
              }}
            >
              {pricing.startPrefix}
              {item.plan}
            </button>
          </div>
        ))}
      </div>
    </>
  )
}

export default PriceCard
